// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ItemCompare-module--wrapper--1F3gC","compare":"ItemCompare-module--compare--2nXrB","userName":"ItemCompare-module--userName--cWDgx"};